package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.GmInventoryItem
import fr.manyverse.app.domain.model.ItemCategory
import fr.manyverse.app.domain.repository.GmInventoryRepository
import fr.manyverse.app.domain.validation.InventoryItemValidator

class UpdateGmInventoryItemUseCase(
    private val gmInventoryRepository: GmInventoryRepository
) {
    suspend operator fun invoke(
        itemId: String,
        name: String,
        category: ItemCategory,
        quantity: Int
    ): Result<GmInventoryItem> {
        InventoryItemValidator.validateForCreation(name, quantity).onFailure {
            return Result.failure(it)
        }
        return gmInventoryRepository.updateItem(itemId, name, category, quantity)
    }
}
